import type { WithdrawMessageReasonFormValues } from "./schema";

export function getDefaultValues(): WithdrawMessageReasonFormValues {
  return {
    withdraw_reason: "",
    withdraw_reason_other: "",
  };
}
